import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Breadcrumbs from '../../layout/Breadcrumbs';

// Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Swiper modules (e.g., Navigation, Pagination, Autoplay)
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css/autoplay'; // Autoplay styles

// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function Team({ showBreadcrumbs = true, showHeader = false }) {
  // Initialize AOS (if not already done in a parent component like App.js)
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 50,
      easing: 'ease-in-out',
      once: false,
    });
  }, []);

  return (
    <>
      {/* Conditionally render Breadcrumbs */}
      {showBreadcrumbs && (
        <Breadcrumbs
          pageTitle="Meet Our Expert Team"
          pageSubtitle="A team of dedicated professionals committed to delivering."
          activePage="Team"
        />
      )}
      <div className="team" id="team">
        {/* Header */}
        {showHeader && (
          <div className="header" data-aos="fade-up" data-aos-delay="100">
            <div className="title">Meet Our Expert Team</div>
            <p className="para">
              A team of dedicated professionals committed to delivering <br /> innovative solutions and exceptional
              results.
            </p>
          </div>
        )}
        {/* Swiper Container */}
        <div className="container" data-aos="fade-up">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1} // Number of slides to show on mobile devices
            spaceBetween={30} // Spacing between slides (in px)
            loop={true} // Loop back to the first slide
            navigation // Adds Prev/Next arrows
            pagination={{ clickable: true }} // Adds bullet pagination
            className="team-slider"
            autoplay={{ // Uncomment if you want autoplay
              delay: 5000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              // when window width is >= 640px
              640: {
                slidesPerView: 2,
              },
              // when window width is >= 768px
              768: {
                slidesPerView: 3,
              },
              // when window width is >= 1024px
              1024: {
                slidesPerView: 4,
              },
            }}
          >

              {/* Team Member 1 Bobby Buttar*/}
             {/* <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/bobby_buttar.jpg" alt="Bobby Buttar" />
                <h5>Bobby Buttar</h5>
                <p>CCO</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide> */}

            {/* Team Member 2  Mahesh Sharma */}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/mahesh_sharma.jpg" alt="Mahesh Sharma" />
                <h5>Mahesh Sharma</h5>
                <p>Project Manager (PMP Certified)</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>


             {/* Team Member 3 Amit Joshi*/}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/amit_joshi.jpg" alt="Amit Joshi" />
                <h5>Amit Joshi</h5>
                <p>Delivery Head</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

             {/* Team Member 4 Priya Bhasin */}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/priya_bhasin.jpg" alt="Priya Bhasin" />
                <h5>Priya Bhasin </h5>
                <p>Director of Operations & Strategy</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

             {/* Team Member 5 Jay Govind */}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/jay_govind.jpg" alt="Jay Govind" />
                <h5>Jay Govind</h5>
                <p>Tech Lead (Full Stack Developer)</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

            {/* Team Member 6 Pankaj Sadiyal*/}
            {/* <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/pankaj_sadiyal.jpg" alt="Pankaj Sadiyal" />
                <h5>Pankaj Sadiyal</h5>
                <p>Solution Architect</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide> */}

               {/* Team Member 7 Vijay Kumar */}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/vijay_kumar.jpg" alt="Vijay Kumar" />
                <h5>Vijay Kumar</h5>
                <p>Full Stack Developer</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

            {/* Team Member 8 Narinder Singh */}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/narinder_singh.jpg" alt="Narinder Singh" />
                <h5>Narinder Singh</h5>
                <p>UI/ UX Designer</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

            {/* Team Member 9 Nisha Rawat */}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/nisha_rawat.jpg" alt="Nisha Rawat" />
                <h5>Nisha Rawat </h5>
                <p>Admin / HR Executive</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>


            {/* Team Member 10 Kapil Durgapal */}
             <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/kapil_durgapal.jpg" alt="Kapil Durgapal" />
                <h5>Kapil Durgapal</h5>
                <p>Tech Lead Associate ( Mern and Mean)</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

            {/* Team Member 11 Kapil Godara */}
            <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/kapil_godara.jpg" alt="Kapil Godara" />
                <h5>Kapil Godara</h5>
                <p>Full Stack Developer</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

            {/* Team Member 12  Aditya Chandel*/}
              <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/aditya_chandel.jpg" alt="Aditya Chandel" />
                <h5>Aditya Chandel</h5>
                <p>IT Manager</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

          {/* Team Member 13  Manveer Singh  */}
        

              <SwiperSlide>
              <div className="box">
                <img src="./assets/images/team/manveer_singh.jpg" alt="Manveer Singh" />
                <h5>Manveer Singh</h5>
                <p>Network Security Officer</p>
                <div className="social">
                  <a href="https://www.facebook.com/SpadezGroup/">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/spadez-solutions-priv-limited/?originalSubdomain=in">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>

             

            {/* Add more team members as needed */}
          </Swiper>
        </div>
      </div>
    </>
  );
}

export default Team;

